import React from 'react';
import { useForm } from 'react-hook-form';

/* Saisie d'un texte court ; une saisie vide revient à annuler. */
export default function PromptDialog({ dialog }) {
  const { message, confirmLabel, defaultValue, resolve } = dialog;
  const { register, handleSubmit } = useForm({ defaultValues: { value: defaultValue } });
  const onSubmit = ({ value }) => resolve(value.trim() || null);
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <label className="block text-[13px] text-[#444] mb-[6px]" htmlFor="feedback-prompt-value">
        {message}
      </label>
      <input
        id="feedback-prompt-value"
        className="input mb-[18px]"
        autoFocus
        {...register('value')}
      />
      <div className="flex justify-end gap-[8px]">
        <button type="button" className="btn" onClick={() => resolve(null)}>
          Annuler
        </button>
        <button type="submit" className="btn btn-primary">
          {confirmLabel}
        </button>
      </div>
    </form>
  );
}
